import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { DealMetricsPage } from "@/components/deal-metrics/deal-metrics-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/deal-metrics",
  loader: async () => {
    const res = await fetch("/api/hubspot/pipelines/deals");
    if (!res.ok) {
      return { pipelines: [] };
    }
    const data = await res.json();
    return { pipelines: data.results ?? [] };
  },
  component: DealMetricsGuard,
});

function DealMetricsGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <DealMetricsPage />;
}
